import { render } from "./mvt-faq.vue?vue&type=template&id=eff9301a"
import script from "./mvt-faq.js?vue&type=script&lang=js"
export * from "./mvt-faq.js?vue&type=script&lang=js"

import "./mvt-faq.vue?vue&type=style&index=0&id=eff9301a&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__